// QL-375 — the client's bank mandates (screen 04). The bank is master for a
// mandate's contents, so this surface never edits them: mandates are created
// and changed only via the public API sync. The one interaction, Follow up
// (group 8), opens the follow-up dialog as an account follow-up of the
// mandate's accounts; the mandate rides onto the successor goal.

// Local translations
export const T = {
  en_GB: {
    mandates: "Mandates",
    mandatesDescription:
      "Investment mandates synced from the bank — the permitted allocation per instrument. Read-only: the bank is the only writer.",
    active: "active",
    pending: "awaiting bank",
    followup: "Follow up",
    followupNoAccounts:
      "Nothing to follow up: none of the accounts the bank named on this mandate is a known account of this client. They appear once the bank syncs them.",
    error: "Error",
    ok: "OK",
    externalId: "External ID",
    mode: "Mode",
    modeFixed: "Fixed weights",
    modeMinMax: "Min/max weights",
    accounts: "Accounts",
    linkedGoal: "Linked goal",
    vendor: "Vendor",
    notSet: "—",
    instrument: "instrument",
    instruments: "instruments",
    isin: "ISIN",
    name: "Name",
    minimum: "Minimum",
    default: "Default",
    maximum: "Maximum",
    weight: "Weight",
  },
  nb_NO: {
    mandates: "Mandater",
    mandatesDescription:
      "Investeringsmandater synkronisert fra banken — tillatt allokering per instrument. Skrivebeskyttet: banken er eneste skriver.",
    active: "aktiv",
    pending: "venter på bank",
    followup: "Oppfølging",
    followupNoAccounts:
      "Ingenting å følge opp: ingen av kontoene banken har knyttet til mandatet er en kjent konto for denne kunden. De vises når banken synkroniserer dem.",
    error: "Feil",
    ok: "OK",
    externalId: "Ekstern ID",
    mode: "Modus",
    modeFixed: "Faste vekter",
    modeMinMax: "Min/maks-vekter",
    accounts: "Kontoer",
    linkedGoal: "Tilknyttet mål",
    vendor: "Leverandør",
    notSet: "—",
    instrument: "instrument",
    instruments: "instrumenter",
    isin: "ISIN",
    name: "Navn",
    minimum: "Minimum",
    default: "Standard",
    maximum: "Maksimum",
    weight: "Vekt",
  },
} as const;
